module.exports = __webpack_public_path__ + "img/58.3e305a06.png";